import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';

import {
  makeOrderDeliveryById,
  makeOrderInvoiceById,
  makeTransactionStatusById,
} from '../../../redux/selectors/orderById';
import DeliverySection from './DeliverySection';

const mapStateToProps = (_initialOwnState, initialOwnProps) => {
  const transactionID = initialOwnProps.transactionID;
  const selector = createStructuredSelector({
    invoiceData: makeOrderInvoiceById(transactionID),
    deliveryData: makeOrderDeliveryById(transactionID),
    transactionStatus: makeTransactionStatusById(transactionID),
  });

  return state => selector(state);
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(DeliverySection);
